<template>
  <div class="body">
    <!-- 顶部信息栏（与 realData 大屏风格一致） -->
    <div
      style="position:absolute;top:25px;left:60px;width:350px;height:60px;display:flex"
    >
      <img
        src="../../../../static/image/screen/bg2.png"
        alt=""
        style="width:280px;height:92px;position:relative;"
      />
      <div
        style="position:absolute;top: 30px;color: #00A2FD;font-size: 20px;left: 25px;"
      >
        SN号：{{ form.deviceSn || "—" }}
      </div>
    </div>
    <div class="head">
      <div style="width:1087px;height:113px;">
        <img
          src="../../../../static/image/screen/title2.png"
          alt=""
          style="width:100%;height:100%;position:relative;"
        />
      </div>

      <div style="position:absolute;top: 25px;display:flex;">
        <div>
          <img :src="imgLogo" alt="" style="height: 60px;" />
        </div>
        <span
          style="font-family: FZZYJW--GB1-0;font-size: 50px;color: #ffffff;margin-top: -5px;"
          >KOPA金邦云平台</span
        >
      </div>
    </div>
    <div
      style="position:absolute;top:25px;right:40px;width:350px;height:60px;display:flex"
    >
      <img
        src="../../../../static/image/screen/bg2.png"
        alt=""
        style="width:280px;height:92px;position:relative;"
      />
      <img
        src="../../../../static/image/screen/bank.png"
        alt=""
        style="width:119px;height:92px;margin-left:-25px;cursor:pointer"
        @click="goBack"
      />
      <div
        style="position:absolute;top: 30px;color: #00A2FD;font-size: 20px;left: 34px;"
      >
        {{ nowTime }}
      </div>
    </div>

    <!-- 主体：左右结构 -->
    <div class="bms-monitor-container">
      <div class="realtime-layout">
        <!-- 左侧：设备类型切换按钮 -->
        <div class="type-sidebar">
          <!-- <div class="sidebar-title">设备类型</div> -->
          <button
            v-for="t in deviceTypes"
            :key="t"
            :class="['type-btn', form.deviceType === t ? 'active' : '']"
            @click="selectType(t)"
          >
            {{ typeLabel(t) }}
          </button>
        </div>

        <!-- 右侧：字段/值 5×5 网格 + 分页 -->
        <div class="data-panel">
          <div class="field-grid">
            <div
              class="field-cell"
              v-for="item in pagedList"
              :key="item.sortKey"
            >
              <div class="field-name" :title="item.name">{{ item.name }}</div>
              <div class="field-value" :title="String(item.value)">
                {{ item.value }}
              </div>
            </div>
            <div v-if="!displayList.length" class="field-empty">
              暂无实时数据
            </div>
          </div>

          <!-- 分页容器常驻占位，避免切换类型时高度跳动 -->
          <div class="pager">
            <el-pagination
              v-if="displayList.length"
              background
              small
              layout="prev, next"
              :total="displayList.length"
              :page-size="pageSize"
              :current-page.sync="currentPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { FIELD_LABELS, FIELD_VALUE_MAPS } from "./fieldLabels";

// 实时报表实体的元数据字段，展示时过滤掉，避免噪声
const EXCLUDE_FIELDS = [
  "id",
  "stationNo",
  "reportTime",
  "isPeriod",
  "lnxallSn",
  "createDate",
  "updateDate",
  "creater",
  "updater",
  "hasDelete",
  "reportId",
  "orgId",
  "createTime",
  "updateTime",
  "deleted",
  "no",
  "funcId",
  "online",
  "Online"
];

// 每页字段数：5 列 × 6 行
const PAGE_SIZE = 30;

// 预留/占位字段（SQL 注释为「预留」的列）不展示
const RESERVED_LABELS = ["预留"];

// 设备类型的中文显示名（仅用于左侧按钮文案，取值仍用英文代码）
// 未列出的类型（BMS/EMS/STS）原样显示代码。
const TYPE_LABELS = {
  PCS: "变流器",
  CELL: "电芯",
  TMS: "液冷",
  DIDO: "干接点"
};

// 仅展示顺序表中的字段，其余字段隐藏。
const PCS_FIELD_ORDER = [
  "输出AB线电压(V)",
  "输出BC线电压(V)",
  "输出CA线电压(V)",
  "输出A相电压(V)",
  "输出B相电压(V)",
  "输出C相电压(V)",
  "输出A相电流(A)",
  "输出B相电流(A)",
  "输出C相电流(A)",
  "电感A相电流(A)",
  "电感B相电流(A)",
  "电感C相电流(A)",
  "电网频率(Hz)",
  "当前电网相序",
  "交流A相有功功率(kW)",
  "交流B相有功功率(kW)",
  "交流C相有功功率(kW)",
  "交流A相视在功率(kVA)",
  "交流B相视在功率(kVA)",
  "交流C相视在功率(kVA)",
  "交流A相无功功率(kVar)",
  "交流B相无功功率(kVar)",
  "交流C相无功功率(kVar)",
  "交流输出总有功功率(kW)",
  "交流输出总无功功率(kVar)",
  "交流输出总视在功率(kVA)",
  "交流功率因数",
  "电池电压(V)",
  "电池电流(A)",
  "充放电状态",
  "直流功率(kW)",
  "直流总电流(A)",
  "总母线电压(V)",
  "正母线电压(V)",
  "负母线电压(V)",
  "工作状态",
  "系统故障",
  "IGBT温度(℃)",
  "环境温度(℃)",
  "电感温度(℃)",
  "当前实际充放电工作模式",
  "并离网状态",
  "DSP版本软件V信息",
  "DSP版本软件B信息",
  "DSP版本软件D信息",
  "CPLD版本软件V信息",
  "CPLD版本软件B信息",
  "CPLD版本软件D信息",
  "A相功率因数",
  "B相功率因数",
  "C相功率因数",
  "直流历史充电量(kWh)",
  "直流日充电量(kWh)",
  "直流历史放电量(kWh)",
  "直流日放电量(kWh)",
  "交流历史充电量(kWh)",
  "交流日充电量(kWh)",
  "交流历史放电量(kWh)",
  "交流日放电量(kWh)",
  "绝缘检测值Rx(kΩ)",
  "绝缘检测值Ry(kΩ)",
  "硬件故障字1",
  "硬件故障字2",
  "电网故障字",
  "母线故障字",
  "交流电容故障字",
  "系统故障字",
  "开关故障字",
  "其他故障字"
];

// BMS（电池管理）字段展示顺序；只展示顺序表中的字段，其余隐藏。
const BMS_FIELD_ORDER = [
  "主正继电器状态",
  "主负继电器状态",
  "主回路预充继电器状态",
  "电池状态",
  "故障数",
  "总电压(V)",
  "总电流(A)",
  "电池soc(%)",
  "电池soh(%)",
  "单体最高电压(mV)",
  "单体最低电压(mV)",
  "单体平均电压(mV)",
  "最高单体电压位置",
  "最低单体电压位置",
  "最高单体温度(℃)",
  "最低单体温度(℃)",
  "平均单体温度(℃)",
  "最高温度探头位置",
  "最低温度探头位置",
  "最大脉冲放电电流(A)",
  "最大脉冲充电电流(A)",
  "最大持续放电电流(A)",
  "最大持续充电电流(A)",
  "绝缘阻值(预留)",
  "故障状态字1",
  "故障状态字2",
  "DIO状态字"
];

// TMS（液冷）字段展示顺序；只展示顺序表中的字段，其余隐藏。
const TMS_FIELD_ORDER = [
  "水泵运行状态",
  "压缩机运行状态1",
  "压缩机运行状态2",
  "电加热运行状态",
  "冷凝风机运行状态",
  "机组出水温度(℃)",
  "机组回水温度(℃)",
  "机组出水压力(Bar)",
  "机组回水压力(Bar)",
  "机组外环境温度(℃)",
  "补液水泵状态",
  "故障告警",
  "液冷机组控制模式(读)",
  "机组设定温度(读)"
];

// STS（静态切换开关）字段展示顺序；只展示顺序表中的字段，其余隐藏。
const STS_FIELD_ORDER = [
  "DSP版本软件V信息",
  "DSP版本软件B信息",
  "DSP版本软件D信息",
  "CPLD版本软件V信息",
  "CPLD版本软件B信息",
  "CPLD版本软件D信息",
  "STS导通状态",
  "晶闸管闭合信号",
  "STS状态",
  "STS温度(℃)",
  "电网频率(Hz)",
  "电网A相电压有效值(V)",
  "电网B相电压有效值(V)",
  "电网C相电压有效值(V)",
  "电网AB线电压有效值(V)",
  "电网BC线电压有效值(V)",
  "电网CA线电压有效值(V)",
  "电网A相电流有效值(A)",
  "电网B相电流有效值(A)",
  "电网C相电流有效值(A)",
  "电网A相有功功率(kW)",
  "电网B相有功功率(kW)",
  "电网C相有功功率(kW)",
  "电网A相无功功率(kVAr)",
  "电网B相无功功率(kVAr)",
  "电网C相无功功率(kVAr)",
  "电网A相视在功率(kVA)",
  "电网B相视在功率(kVA)",
  "电网C相视在功率(kVA)",
  "电网A相功率因数",
  "电网B相功率因数",
  "电网C相功率因数",
  "总有功功率(kW)",
  "总无功功率(kVAr)",
  "总视在功率(kVA)",
  "硬件故障字1",
  "硬件故障字2",
  "电网故障字",
  "母线故障字",
  "交流电容故障字",
  "系统故障字",
  "开关故障字",
  "其他故障字"
];

// 序列字段配置：这些字段的值是逗号分隔的序列，需展开成一格一个值。
// 键为设备类型；match 为后端 JSON key 的小写形式（兼容 SQL 列名差异），
// base 为展开后的名称前缀，unit 为**字段名**的单位后缀（如「单体电压1(mV)」），
// 值本身不带单位。数组顺序 = 展开后展示顺序。
const SERIES_FIELDS = {
  CELL: [
    { match: ["voltagemv"], base: "单体电压", unit: "mV" },
    { match: ["temperature"], base: "单体温度", unit: "℃" }
  ],
  DIDO: [
    { match: ["di"], base: "接入点", unit: "", start: 0 },
    { match: ["dofield", "dout"], base: "数字输出", unit: "" }
  ]
};

export default {
  name: "RealtimeQuery",
  data() {
    return {
      deviceTypes: ["BMS", "CELL", "PCS", "TMS", "STS", "DIDO"],
      form: {
        deviceType: "", // 默认选中第一个，由 created 中 selectType 设定
        deviceSn: "",
        deviceName: ""
      },
      stationNo: "",
      reportTime: "",
      nowTime: "",
      imgLogo: "",
      hasData: false,
      loading: false,
      polling: false,
      timer: null,
      rawData: {},
      pageSize: PAGE_SIZE,
      currentPage: 1
    };
  },
  computed: {
    // 全部字段（过滤元数据）
    // 序列字段（CELL 单体电压/温度、DIDO 数字输入/输出）是逗号分隔值，
    // 展开成一格一个值；展开顺序按 SERIES_FIELDS 配置顺序追加到列表末尾。
    displayList() {
      const data = this.rawData || {};
      const seriesCfg = SERIES_FIELDS[this.form.deviceType] || [];

      // 序列字段原始值先挑出来（不进主列表，稍后展开）
      // 按 match 的小写形式在 data 中匹配真实 key 取值（兼容 Java 属性名大小写差异）
      const seriesRaw = seriesCfg.map(cfg => {
        for (const k of Object.keys(data)) {
          if (cfg.match.indexOf(k.toLowerCase()) !== -1) return data[k];
        }
        return null;
      });

      // 这些字段是序列字段，从主列表中剔除（稍后逐格展开）
      const seriesKeys = new Set();
      seriesCfg.forEach(cfg => cfg.match.forEach(m => seriesKeys.add(m)));

      // 设备类型 -> 顺序表；顺序表中出现的标签集合用于命名冲突时优先选「规范字段」
      const ORDER_MAP = {
        PCS: PCS_FIELD_ORDER,
        BMS: BMS_FIELD_ORDER,
        TMS: TMS_FIELD_ORDER,
        STS: STS_FIELD_ORDER
      };
      const order = ORDER_MAP[this.form.deviceType];
      const orderLabelSet = new Set(order || []);

      // 普通字段判定：非元数据、非序列、非预留
      const isPlainKey = k => {
        if (EXCLUDE_FIELDS.indexOf(k) !== -1) return false;
        if (seriesKeys.has(k.toLowerCase())) return false;
        const name = this.labelOf(k, orderLabelSet);
        if (RESERVED_LABELS.indexOf(String(name).trim()) !== -1) return false;
        return true;
      };

      // 计算有序 key 列表：BMS/PCS 按各自 FIELD_ORDER 排序且只展示顺序表中字段；
      // 其余类型按自然顺序（CELL/DIDO 序列字段仍随后展开）
      let orderedKeys;
      if (order && order.length) {
        const labelToKey = {};
        Object.keys(data).forEach(k => {
          if (!isPlainKey(k)) return;
          const name = this.labelOf(k, orderLabelSet);
          if (!(name in labelToKey)) {
            labelToKey[name] = k;
          } else {
            // 同名标签（如 READ1 与取值为 null 的 rEAD1 碰撞）优先保留有值的 key
            const cur = labelToKey[name];
            const curEmpty =
              data[cur] === null || data[cur] === undefined || data[cur] === "";
            const newEmpty =
              data[k] === null || data[k] === undefined || data[k] === "";
            if (curEmpty && !newEmpty) labelToKey[name] = k;
          }
        });
        const used = new Set();
        orderedKeys = [];
        order.forEach(name => {
          const k = labelToKey[name];
          if (k !== undefined && !used.has(k)) {
            used.add(k);
            orderedKeys.push(k);
          }
        });
        // 仅展示顺序表中的字段，其余字段隐藏（不追加）
      } else {
        orderedKeys = Object.keys(data).filter(k => isPlainKey(k));
      }

      const list = [];
      orderedKeys.forEach(k => {
        list.push({
          sortKey: k,
          name: this.labelOf(k, orderLabelSet),
          value: this.valueOf(k, data[k])
        });
      });

      // 追加展开的序列字段（一格一个值）
      seriesCfg.forEach((cfg, si) => {
        this.splitSeries(seriesRaw[si]).forEach((v, i) => {
          // start：序号起始值，默认 1（如 单体电压1）；DIDO 的「接入点」用 0 起（接入点0…）
          const idx = i + (cfg.start !== undefined ? cfg.start : 1);
          list.push({
            sortKey: cfg.base + "_" + i,
            // 单位放在字段名后面，如「单体电压1(mV)」；值不带单位
            name: cfg.base + idx + (cfg.unit ? "(" + cfg.unit + ")" : ""),
            value: v
          });
        });
      });

      return list;
    },
    // 当前页字段（最多 30 个）
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.displayList.slice(start, start + this.pageSize);
    }
  },
  watch: {
    // 数据变化后若当前页超出范围，回退到最后一页
    displayList() {
      const maxPage = Math.max(
        1,
        Math.ceil(this.displayList.length / this.pageSize)
      );
      if (this.currentPage > maxPage) this.currentPage = maxPage;
    }
  },
  methods: {
    // 归一化字段 key：转小写并去掉下划线，兼容后端对同一物理字段的多种命名
    // （如 READ1 / read_1 / rEAD1 实为设备协议的同一字段「最高单体电压位置」）。
    normKey(k) {
      return String(k)
        .toLowerCase()
        .replace(/_/g, "");
    },
    // 字段名 -> 中文标签：优先使用 SQL 字段注释映射（按设备类型），无映射时回退到可读化名称。
    // 同一物理字段后端可能有多种命名（READ1/read_1/rEAD1），归一化后若命中多个 key，
    // 优先选标签已纳入当前类型展示顺序表（BMS_FIELD_ORDER 等）的「规范字段」，避免被报警等次要语义覆盖。
    // 注意：不能让「精确匹配」抢先于规范字段优先，否则 read_1 会被精确判成报警标签而丢失位置数据。
    labelOf(k, orderLabelSet) {
      const map = FIELD_LABELS[this.form.deviceType];
      if (!map) return this.pretty(k);
      const nk = this.normKey(k);
      const hits = Object.keys(map).filter(key => this.normKey(key) === nk);
      if (hits.length) {
        // 1) 优先选已纳入当前类型展示顺序表的「规范字段」（如 READ1 位置字段）
        if (orderLabelSet && orderLabelSet.size) {
          const pref = hits.find(key => orderLabelSet.has(map[key]));
          if (pref) return map[pref];
        }
        // 2) 否则回退精确匹配（兼容 rackVoltage 等仅大小写不同的字段）
        if (Object.prototype.hasOwnProperty.call(map, k)) return map[k];
        // 3) 再取归一化命中的第一个
        return map[hits[0]];
      }
      // 无归一化命中时仍支持精确匹配，最后回退可读化名称
      if (Object.prototype.hasOwnProperty.call(map, k)) return map[k];
      return this.pretty(k);
    },
    // 驼峰/带前缀字段转可读中文风格说明（仅做简单分隔，技术名仍保留）
    pretty(k) {
      return k
        .replace(/([A-Z])/g, " $1")
        .replace(/^ /, "")
        .trim();
    },
    // 序列字段（CELL 单体电压/温度、DIDO 数字输入/输出）拆分为数组：
    // 支持逗号分隔字符串或数组，去掉空项
    splitSeries(raw) {
      if (raw === null || raw === undefined || raw === "") return [];
      const arr = Array.isArray(raw) ? raw : String(raw).split(",");
      return arr
        .map(v => (v === null || v === undefined ? "" : String(v).trim()))
        .filter(v => v !== "");
    },
    fmt(v) {
      if (v === null || v === undefined || v === "") return "—";
      if (typeof v === "boolean") return v ? "是" : "否";
      if (typeof v === "object") return JSON.stringify(v);
      return v;
    },
    // 枚举字段的值翻译：若字段在 FIELD_VALUE_MAPS 中有码值->中文映射，则只显示中文；
    // 无映射时回退普通格式化。同一物理字段后端可能有多种命名（READ1/read_1/rEAD1），
    // 归一化后若命中多个 key，优先选枚举为空的「规范数值字段」（如 READ1 位置数值），
    // 避免把位置/电流数值误翻成报警文案（read_1 的 正常/故障 等）。
    valueOf(k, v) {
      const set = FIELD_VALUE_MAPS[this.form.deviceType];
      if (set) {
        const nk = this.normKey(k);
        const candidates = [];
        if (Object.prototype.hasOwnProperty.call(set, k)) candidates.push(k);
        Object.keys(set).forEach(key => {
          if (key !== k && this.normKey(key) === nk) candidates.push(key);
        });
        // 枚举长度升序：空枚举（规范数值字段）优先于报警等带文案的枚举
        candidates.sort(
          (a, b) => Object.keys(set[a]).length - Object.keys(set[b]).length
        );
        const m = candidates.length ? set[candidates[0]] : null;
        if (m && Object.keys(m).length) {
          let txt = m[v];
          if (txt === undefined) txt = m[String(v)];
          if (txt === undefined && typeof v === "number") txt = m[v];
          if (txt === undefined && !isNaN(Number(v))) txt = m[Number(v)];
          // 仅保留中文描述，去掉「（原码值）」后缀
          if (txt !== undefined) return txt;
        }
      }
      return this.fmt(v);
    },
    // 与 realData 一致的平台 Logo 获取
    getLogo() {
      this.$store.dispatch("form/handle", {
        url: "/battery/offline/query",
        data: { companyId: localStorage.getItem("companyId") },
        method: "get2",
        callback: resp => {
          if (resp && resp.logo) {
            this.imgLogo = resp.logo;
          }
        }
      });
    },
    // 下发取数请求（POST /battery/realtime/query），向设备请求最新 MQTT 数据。
    // silent=true 时（轮询/后台场景）失败不弹错误，避免每秒刷屏。
    async triggerQuery(silent = false) {
      if (!this.form.deviceType || !this.form.deviceSn) return false;
      try {
        await request.post2("/battery/realtime/query", {
          deviceType: this.form.deviceType,
          deviceSn: this.form.deviceSn,
          mi: 5
        });
        return true;
      } catch (e) {
        if (!silent) this.$message.error("下发取数请求失败：" + e);
        return false;
      }
    },
    // 读取已落库的实时结果（轮询/手动共用）
    async loadData(showOverlay = false) {
      if (!this.form.deviceType || !this.form.deviceSn) return;
      if (showOverlay) this.loading = true;
      else this.polling = true;
      try {
        const resp = await request.get2("/battery/realtime/data", {
          deviceType: this.form.deviceType,
          deviceSn: this.form.deviceSn
        });
        this.stationNo = resp.stationNo || "";
        this.reportTime = resp.reportTime || "";
        this.nowTime = resp.reportTime || "";
        this.hasData = !!resp.hasData;
        this.rawData = resp.data || {};
      } catch (e) {
        // 轮询失败不打断，仅提示一次
        if (showOverlay) this.$message.error("获取实时数据失败：" + e);
      } finally {
        this.loading = false;
        this.polling = false;
      }
    },
    // 设备类型按钮文案：有中文名用中文，否则原样显示代码
    typeLabel(t) {
      return TYPE_LABELS[t] || t;
    },
    // 切换设备类型：清空旧数据，回第一页，重起 1s 轮询并立即取数一次
    selectType(type) {
      if (this.form.deviceType === type) return;
      this.form.deviceType = type;
      this.currentPage = 1;
      this.hasData = false;
      this.rawData = {};
      this.stationNo = "";
      this.reportTime = "";
      this.startTimer();
      this.pollOnce();
    },
    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.pollOnce(), 1000);
    },
    // 每次轮询：先下发取数请求(query) 触发设备上报，再读取已落库结果(data)
    async pollOnce() {
      await this.triggerQuery(true);
      await this.loadData(false);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {
    this.getLogo();
    const q = this.$route.query;
    if (q.deviceSn) this.form.deviceSn = q.deviceSn;
    if (q.deviceName) this.form.deviceName = q.deviceName;
    // 默认选中设备类型（路由带则用路由的，否则用第一个），并自动开始每秒轮询取数
    // 若路由传入的类型已被隐藏（不在按钮列表中），回退到第一个可选类型
    const initType =
      q.deviceType && this.deviceTypes.indexOf(q.deviceType) !== -1
        ? q.deviceType
        : this.deviceTypes[0];
    this.selectType(initType);
  },
  beforeDestroy() {
    this.stopTimer();
  }
};
</script>

<style lang="less">
@primary-color: #3498db;
@secondary-color: #2ecc71;
@danger-color: #e74c3c;
@warning-color: #f39c12;
@dark-color: #34495e;
@light-color: #ecf0f1;
@card-bg: #ffffff;
@body-bg: #f5f7fa;

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

// 与 realData 大屏风格一致：整页背景图 + 深底浅字
.body {
  padding: 0px;
  margin: 0px;
  color: #222;
  font-family: "微软雅黑";
}
.body {
  font-family: "Roboto", sans-serif;
  // 与 realData 同一张背景图
  background-image: url("../../../../static/image/screen/bg.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-blend-mode: overlay;
  min-height: 100vh;
}

.head {
  height: 138px;
  display: flex;
  justify-content: center;
  background-size: 100% 100%;
  position: relative;
}

// 主体容器 —— 与 realData 卡片一致：白底 + 8px 圆角 + 浅阴影，置于居中容器内
.bms-monitor-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Roboto", "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #333;
  line-height: 1.6;
}

// 左右结构：左侧类型按钮，右侧字段网格（拉伸对齐，左栏高度与右栏一致）
.realtime-layout {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

.type-sidebar {
  flex: 0 0 172px;
  width: 172px;
  background-color: @card-bg;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 14px 12px;
  // 纵向 flex：标题固定，7 个类型按钮平分剩余高度，占满整栏
  display: flex;
  flex-direction: column;
  gap: 10px;

  .sidebar-title {
    flex: 0 0 auto;
    font-size: 14px;
    font-weight: 600;
    color: @dark-color;
    text-align: center;
  }

  .type-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 12px;
    border: none;
    border-radius: 6px;
    background: #f0f2f5;
    color: @dark-color;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s;

    &:hover {
      background: #e6f3fb;
    }
    &.active {
      background: @primary-color;
      color: #fff;
      font-weight: 600;
    }
  }
}

// 右侧面板：仅字段/值网格 + 分页
.data-panel {
  flex: 1;
  min-width: 0;
  background-color: @card-bg;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 16px 18px;
}

// 5 列 × 6 行网格，每页 30 个字段（固定 6 行高度，避免末页塌陷影响左栏对齐）
.field-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 76px;
  gap: 10px;
  // 6 行 × 76px + 5 × 10px 间距 = 506px
  min-height: 506px;
}

// 单个字段：字段名在上、值在下，作为一个整体卡片
.field-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafcff;
  padding: 6px 8px;
  overflow: hidden;

  .field-name {
    width: 100%;
    font-size: 12px;
    color: #909399;
    line-height: 1.3;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .field-value {
    width: 100%;
    margin-top: 6px;
    font-size: 16px;
    font-weight: 600;
    color: @dark-color;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// 空数据占位：绝对铺满整个 .field-grid，保证水平 + 垂直都居中（不依赖 grid 列/行跨度）
.field-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

// 分页（容器固定高度常驻，靠右下角，避免切换类型/无数据时整页高度跳动）
.pager {
  margin-top: 16px;
  min-height: 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/realtimeQuery.vue